import { cn } from '@rematter/ui-web/lib';

import { ItemGroupRecord } from '../../../types/inventoryItem';

import { ItemGroupFormFields } from './ItemGroupFormFields';

type Props = {
  itemGroup?: ItemGroupRecord | null;
  disabled?: boolean;
  className?: string;
};

export const ItemGroupDetailsForm = ({
  itemGroup,
  disabled = false,
  className,
}: Props) => (
  <div className={cn('@ItemGroupDetailsForm', className)}>
    <ItemGroupFormFields
      disabled={disabled}
      showTimestamps
      itemGroup={itemGroup}
    />
  </div>
);
